module.exports = __webpack_public_path__ + "static/mask_lo_081-4fc7b56093ef7cdb4bced1e30db7c75d.jpg";